export default __webpack_public_path__ + "static/media/checkbox-multiple-blank-outline.87a6eb67.svg";